import '../Libs/Bootstrap/js/dist/dom/data.js'
import '../Libs/Bootstrap/js/dist/dom/event-handler.js'
import '../Libs/Bootstrap/js/dist/dom/manipulator.js'
import '../Libs/Bootstrap/js/dist/dom/selector-engine.js'

import '../Libs/Bootstrap/js/dist/base-component.js'
import '../Libs/Bootstrap/js/dist/collapse.js'

import '../Libs/DeviceDetection/01_modernizr.3.5.0.min.js'
import '../Libs/DeviceDetection/02_DeviceDetection.js'

// Project Feature modules
import { AccordionDesignTransformation } from './Modules/AccordionDesignTransformation.js'
import { DesktopPageNavigation } from './Modules/DesktopPageNavigation.js'
import { JobPostingFilter } from './Modules/JobPostingFilter.js'
import { MobilePageNavigation } from './Modules/MobilePageNavigation.js'
import { ScrollDirectionEventDispatcher } from './Modules/ScrollDirectionEventDispatcher.js'
import { ScrollToTop } from './Modules/ScrollToTop.js'
import { StickyHeader } from './Modules/StickyHeader.js'
import { AnimateOnScrollInitializer } from './Modules/AnimateOnScrollInitializer.js'
import { EventFilter } from './Modules/EventFilter.js'
import { CustomSelect } from './Modules/CustomSelect.js'
import { ContactFormHelper } from './Modules/ContactFormHelper.js'
import { FlipCard } from './Modules/FlipCard.js'
import { Helpers } from './Modules/Helpers.js'
import { DownloadsFilter } from './Modules/DownloadsFilter.js'
import LanguageButton from './LanguageButton.js'

const initNodeTypesOnLoad = function () {
    new ScrollDirectionEventDispatcher()
    new StickyHeader()
    new ScrollToTop()
    new DesktopPageNavigation()
    new MobilePageNavigation()
    new AccordionDesignTransformation()
    new JobPostingFilter()
    new EventFilter()
    new CustomSelect()
    new ContactFormHelper()
    new FlipCard()
    new DownloadsFilter()
    Helpers.dynamicMenuWidth()
    new AnimateOnScrollInitializer()
    new LanguageButton()
}

if (document.readyState != 'loading') {
    initNodeTypesOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad)
}
